<!--
 * @Author:
 * @Description:
 * @Date: 2025-04-09 19:21:31
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/risk/components/add-blackList-item/batch.vue
-->
<template>
  <div>
    <div class="add-black-list-item-batch">
      <validate-component ref="AddBlackListItemBatch" :validation-condition="validationCondition"></validate-component>
    </div>
    <div class="example-file">
      <!-- <h3 class="example-file-title">{{ $t('message.risk.exampleFile.title') }}</h3> -->
      <h4 class="example-file-subtitle">{{ $t('message.risk.exampleFile.subtitle') }}</h4>
      <ul class="example-file-list">
        <li class="example-file-list-item">
          <p><span class="dot"></span>{{ $t('message.risk.exampleFile.format') }} <span class="file-type">{{
            $t('message.risk.exampleFile.csv') }}</span> {{ $t('message.risk.exampleFile.withColumns') }}</p>
          <p class="example-file-list-item-content margin-left-28"> <span class="columns">{{
            $t('message.risk.exampleFile.columnNames') }}</span></p>
        </li>
        <li class="example-file-list-item">
          <p><span class="dot"></span>{{ $t('message.risk.exampleFile.valueCanBe') }} <span class="highlight">{{
            $t('message.risk.exampleFile.originalData') }}</span>{{ $t('message.risk.exampleFile.or') }}<span
              class="highlight">{{
                $t('message.risk.exampleFile.transactionOrEmail') }}</span>
            <!-- <span>{{
              $t('message.risk.exampleFile.transactionOrEmailDesc') }}</span> -->
          </p>
        </li>
        <li class="example-file-list-item">
          <p class="example-file-list-item-title">
            <span class="dot"></span>{{ $t('message.risk.exampleFile.typeShouldBe') }}:
          </p>
          <ul class="example-file-list-item-content">
            <li class="example-file-list-item-content-item margin-left-28">
              <span class="dot"></span><span class="file-type">{{ $t('message.risk.exampleFile.typeC') }}</span>
              <!-- <span>{{
                $t('message.risk.exampleFile.typeCDesc') }}</span> -->
            </li>
            <li class="example-file-list-item-content-item margin-left-28">
              <span class="dot"></span><span class="file-type">{{ $t('message.risk.exampleFile.typeM') }}</span>
              {{
                $t('message.risk.exampleFile.typeMDesc') }}
            </li>
          </ul>
        </li>
        <li class="example-file-list-item">
          <p class="example-file-list-item-content">
            <span class="dot"></span>{{ $t('message.risk.exampleFile.statusShouldBe') }} <span class="status-active">{{
              $t('message.risk.exampleFile.active') }}</span> {{ $t('message.risk.exampleFile.or') }} <span
              class="status-inactive">{{ $t('message.risk.exampleFile.inactive') }}</span>
          </p>
        </li>
        <li class="example-file-list-item">
          <p class="example-file-list-item-title">
            <span class="dot"></span>{{ $t('message.risk.exampleFile.expiryDate') }}<span class="date-format">{{
              $t('message.risk.exampleFile.dateFormat') }}</span>
          </p>
        </li>
        <li class="example-file-list-item">
          <p class="example-file-list-item-title">
            <span class="dot"></span>{{ $t('message.risk.exampleFile.allValues') }}<span class="highlight">{{
              $t('message.risk.exampleFile.plainText') }}</span>{{ $t('message.risk.exampleFile.noMasking') }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

import ValidateComponent from '@/components/validation/validation.vue'; export default {
  name: 'AddBlackListItemBatch',
  props: {
    libInfo: {
      type: Object,
      default: () => {
        return {
          type: 'EMAIL',
        };
      },
    },
  },
  data() {
    return {
      // templateList: [
      //   {
      //     type: 'CARD_NUMBER_HASH',
      //     templateName: 'blacklist_template.csv',
      //     templateUrl: '/static/template/blacklist_template.csv',
      //   },
      //   {
      //     type: 'PHONE',
      //     templateName: 'blacklist_template_phone.csv',
      //     templateUrl: '/static/template/blacklist_template_phone.csv',
      //   },
      //   {
      //     type: 'IP',
      //     templateName: 'blacklist_template_ip.csv',
      //     templateUrl: '/static/template/blacklist_template_ip.csv',
      //   },
      //   {
      //     type: 'EMAIL',
      //     templateName: 'blacklist_template_email.csv',
      //     templateUrl: '/static/template/blacklist_template_email.csv',
      //   },
      //   {
      //     type: 'EMAIL_DOMAIN',
      //     templateName: 'blacklist_template_email_domain.csv',
      //     templateUrl: '/static/template/blacklist_template_email_domain.csv',
      //   },
      // ],
      validationCondition: [
        {
          key: 'item2',
          type: 'upload_file_v2',
          defValue: '',
          isShowStar: true,
          isChecked: false,
          checked: true,
          description: '',
          infoTips: this.$t('message.risk.addBlacklistdialog.batchRiskTemplateTips'),
          uploadRange: {
            fileSize: 5, // 5M
            uploadFileList: [],
            fileTypeRule: 'text/csv',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.csv' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'csv' }),
            // templateFileName: this.template?.templateUrl,
            // templateFileNameShow: this.template?.templateName,
            templateFileName: '/static/template/blacklist_template.csv',
            templateFileNameShow: 'blacklist_template.csv',
            hideSuccessMessage: true,
          },
          onRemove: (file) => {
            console.log(file, 'file');
          },
        },
      ],
    };
  },
  components: {
    ValidateComponent,
  },
  mounted() {
  },
  methods: {
    handleSubmit() {
    },
    handleCancel() {

    },
    // 校验
    validate() {
      this.$refs.AddBlackListItemBatch.validate();
    },
    /**
    * 获取表整个表单的值
     */
    getFormJson() {
      return this.$refs.AddBlackListItemBatch.getFormJson();
    },
    /**
    * 验证表单
     */
    toFormValid(validCallBack, errorCallBack) {
      this.$refs.AddBlackListItemBatch.toFormValid(validCallBack, errorCallBack);
    },
    /**
    * 异步验证表单
     */
    validateAsync() {
      return this.$refs.AddBlackListItemBatch.validateAsync();
    },
  },
  // computed: {
  //   template() {
  //     return this.templateList.find(item => item.type === this.libInfo.type);
  //   },
  // },
  // watch: {
  //   template: {
  //     immediate: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         this.validationCondition[0].uploadRange.templateFileName = newVal.templateUrl;
  //         this.validationCondition[0].uploadRange.templateFileNameShow = newVal.templateName;
  //       }
  //     },
  //   },
  // },
};
</script>
<style lang="scss">
.drawer-container {
  .drawer-body {
    // 设置滚动条为0
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
<style lang="scss" scoped>
.drawer-container {
  .drawer-body {
    // 设置滚动条为0
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

.add-black-list-item-batch {
  margin-top: 4px;
}

.example-file {
  background: #fff;
  margin-top: 4px;

  .example-file-title {
    font-family: "Urbanist, Avenir, PingFang SC, Microsoft YaHei, Helvetica, Arial, sans-serif";
    font-weight: bold;
    font-size: 18px;
    color: #1A202C;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-bottom: 24px;
  }

  .example-file-subtitle {
    font-family: "Urbanist, Avenir, PingFang SC, Microsoft YaHei, Helvetica, Arial, sans-serif";
    font-weight: 600;
    font-size: 14px;
    color: #1A202C;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .example-file-list {
    padding-left: 0;

    .example-file-list-item {
      border-top: 1px solid #D0D5DD;
      color: #666;
      padding: 16px 0;
      font-family: Urbanist, Avenir, "PingFang SC", "Microsoft YaHei", Helvetica, Arial, sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: #667085;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      &:first-child {
        border-top: none;
      }

      .example-file-list-item-content {
        // margin-top: 8px;

        .example-file-list-item-content-item {
          display: flex;
          align-items: center;

          .dot {
            position: relative;
            bottom: 0;
          }
        }
      }

      .dot {
        position: relative;
        bottom: 2px;
      }
    }
  }

  .file-type {
    color: #CC8406;
  }

  .columns {
    color: #F53F3F;
  }

  .highlight {
    color: #CC8406;
  }

  .status-active {
    color: #00B42A;
  }

  .status-inactive {
    color: #F53F3F;
  }

  .date-format {
    color: #CC8406;
  }

  .margin-top-8 {
    // margin-top: 8px;
  }

  .margin-left-28 {
    margin-left: 20px;
  }

  .dot {
    display: inline-block;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #D0D5DD;
    margin: 0 8px;
  }
}
</style>
<style>
.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #264373;
}
</style>
